type PreparationStage = 'package' | 'scene';

interface PreparationElements {
  panel: Pick<HTMLElement, 'hidden' | 'dataset'>;
  title: Pick<HTMLElement, 'textContent'>;
  detail: Pick<HTMLElement, 'textContent'>;
}

const stageCopy: Record<PreparationStage, { title: string; detail: string }> = {
  package: {
    title: 'BOARDING THE TRAIN',
    detail: 'Downloading the game package. You can return to the Station while it loads.',
  },
  scene: {
    title: 'PREPARING THE TRAIN',
    detail: 'Warming up graphics before you take control…',
  },
};

export class RunPreparationView {
  public constructor(private readonly elements: PreparationElements) {}

  public show(stage: PreparationStage): void {
    const copy = stageCopy[stage];
    this.elements.title.textContent = copy.title;
    this.elements.detail.textContent = copy.detail;
    this.elements.panel.dataset.stage = stage;
    this.elements.panel.hidden = false;
  }

  public hide(): void {
    this.elements.panel.hidden = true;
    delete this.elements.panel.dataset.stage;
  }
}
